/**
 * Main Page file for Content Page
 */

const ContentPage = () => {
  return (
    <div style={{width: '40vw', margin: 'auto'}}>
      <h5 style={{ color: "#fff", textAlign:'center', paddingTop: "25px" }}>
        Content Coming Soon...
      </h5>
    </div>
  );
};

export default ContentPage;
